module.exports = __webpack_public_path__ + "static/img/a113.3b19ee8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a113.jpg
// module id = lBiL
// module chunks = 0